export const fetchOk = (...args) => fetch(...args)
    .then((res) => (res.ok ? res : res.json().then((data) => {
        throw Object.assign(new Error(data.error_message), { name: res.statusText });
    })));

export const toto = 1;
